import { motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";
import Swal from "sweetalert2";

// Asset imports
import homeImageBackground from "../assets/images/homeBackground.png";

// Component imports
import DisheOption from "../components/DisheOption";
import Header from "../components/Header";

// Redux action imports
import { resetDishState } from "../redux/dishes";
import { clearImage } from "../redux/image";
import { setIngredients } from "../redux/ingredients";
import { clearInstructions } from "../redux/instructions";
import { setPrompt } from "../redux/prompt";
import {
  clearAllDishImages,
  clearTitle,
  resetImageGenerationCount,
} from "../redux/title";
import { playAudio } from "../utils/btnAudio";
import DishOption from "./DishOption";
import { IoSearchSharp } from "react-icons/io5";
import { CButton, ContainerHeading } from "../components/CommonComponents";
import Layout from "../components/Layout";
import TestPage from "./TestPage";

export default function DiscoverDishes() {
  const { ingredients } = useSelector((state) => state.ingredients);
  const {
    user: { emailVerified },
  } = useSelector((state) => state.auth.user);
  const abc = useSelector((state) => state.tokens);
  const {
    dishTokens,
    recipeTokens,
  } = useSelector((state) => state.tokens);
  console.log(abc);

  const initialState = {
    Culture: ingredients?.Culture || "",
    IncludedIngredients: ingredients?.IncludedIngredients || "",
    ExcludedIngredients: ingredients?.ExcludedIngredients || "",
    Description: ingredients?.Description || "",
    Occasion: ingredients?.Occasion || "",
    Language: ingredients?.Language || "",
    FreeFlow: ingredients?.FreeFlow || "",
  };

  const [values, setValues] = useState(initialState);
  const [isDishePages, setDishesPage] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // If email is not verified

  useEffect(() => {
    if (!localStorage.getItem("darkMode")) {
      localStorage.setItem("darkMode", "true");
    }

    if (!emailVerified) {
      navigate("/verify-email");
    }
    dispatch(resetDishState());
    dispatch(clearTitle());
    dispatch(clearInstructions());
    dispatch(clearImage());
  }, []);

  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    playAudio();
    e.preventDefault();
    // Data
    const {
      Culture,
      IncludedIngredients,
      ExcludedIngredients,
      Description,
      Occasion,
      Language,
      FreeFlow,
    } = values;

    console.log(values, "value")
    let prompt = `Let's Cook Up Something Delicious!
    
    ###${Culture} dishes ${IncludedIngredients ? `with ${IncludedIngredients}` : ""
      }${ExcludedIngredients ? `that and does not contain ${ExcludedIngredients}` : ""}. 
      ${Description ? ` should be ${Description}` : ""
      }  ${Occasion ? `and be suitable for ${Occasion}. ` : ""} ${FreeFlow ? FreeFlow + ". " : ""
      } ${Language ? `Please write the dish in ${Language}` : ""}`;

    // If no subscription is there
    if (!dishTokens || dishTokens <= 0) {
      Swal.fire({
        icon: "info",
        title: "Please buy a subscription first",
        showConfirmButton: true,
        timer: 2000,
      });

      return;
    }

    if (isDishePages) {
      // If subscription ends
      if (dishTokens <= 0) {
        Swal.fire({
          icon: "info",
          title: "You are out of Search Tokens",
          showConfirmButton: true,
          timer: 2000,
        });

        return;
      }
    } else {
      if (recipeTokens <= 0) {
        Swal.fire({
          icon: "info",
          title: "You are out of Recipe Tokens",
          showConfirmButton: true,
          timer: 2000,
        });

        return;
      }
    }

    let flag = false;
    for (let i = 0; i < Object.keys(values).length; i++) {
      if (Object.values(values)[i].length > 0) {
        flag = true;
      }
    }

    if (flag == true) {

      dispatch(setPrompt(prompt));
      dispatch(setIngredients(values));
      dispatch(clearAllDishImages());
      dispatch(resetImageGenerationCount());

      isDishePages ? navigate("/get-dishes") : navigate("/get-recipe");
      // Swal.fire({
      //   title: "Are you sure?",
      //   text: "By proceeding, you will lose a search token and this can not be un done",
      //   icon: "warning",
      //   showDenyButton: true,
      //   confirmButtonText: "Yes, Proceed!",
      //   denyButtonText: `No`,
      //   showCloseButton: true,
      //   dangerMode: true,
      // }).then(async (result) => {
      //   if (result.isConfirmed) {
      //     isDishePages ? navigate("/get-dishes") : navigate("/get-recipe");
      //   }
      // });
    } else {
      swal({
        icon: "info",
        title: "Please fill atleast one field",
        showConfirmButton: false,
        timer: 2000,
      });
    }
  };

  return (
    <Layout>
      {/* Header */}
      <div className="flex mx-4 my-2 justify-center items-center">
        <ContainerHeading text={"Be As Picky As You Want!"} />
      </div>

      {/* Buttons */}
      <div className="flex w-full bg-white items-center justify-between p-2 rounded-full">
        <CButton
          label={" Get Dishes"}
          variant={isDishePages ? "orange" : "transparent"}
          size={"small"}
          className={"w-full"}
          // type="reset"
          onClick={() => {
            setDishesPage(true);
          }}
        />
        <CButton
          label={"Get Recipe"}
          variant={!isDishePages ? "orange" : "transparent"}
          size={"small"}
          className={"w-full"}
          // type="reset"
          onClick={() => {
            setDishesPage(false);
          }}
        />
      </div>

      {/* Fields */}
      {/* <form onSubmit={onSubmit} className=""> */}
      <div className="flex flex-col justify-center items-center">
        <DishOption
          name="Culture"
          value={values.Culture}
          handleChange={handleChange}
          isDishePages={isDishePages}
          title="Culture or Type"
          placeholder="Italian, Somalian, Chinese, American"
        />
        <DishOption
          name="IncludedIngredients"
          value={values.IncludedIngredients}
          handleChange={handleChange}
          isDishePages={isDishePages}
          title="Ingredients Included"
          placeholder="Chicken, Mushrooms, Red Chili Flakes"
        />
        <DishOption
          name="ExcludedIngredients"
          value={values.ExcludedIngredients}
          handleChange={handleChange}
          isDishePages={isDishePages}
          title="Ingredients Excluded"
          placeholder="Broccoli, Kraft Cheese, Fish"
        />
        <DishOption
          name="Description"
          value={values.Description}
          handleChange={handleChange}
          isDishePages={isDishePages}
          title="Description or Taste"
          placeholder="Spicy, Easy to Cook, 18th Century, Savory, Exotic"
        />
        <DishOption
          name="Occasion"
          value={values.Occasion}
          handleChange={handleChange}
          isDishePages={isDishePages}
          title="For What Occasion"
          placeholder="First Date, Quick Dinner, Breakfast With The Kids, Lazy Sunday"
        />
        <DishOption
          name="Language"
          value={values.Language}
          handleChange={handleChange}
          isDishePages={isDishePages}
          title="What Language"
          placeholder="French, Spanish, Arabic, Chinese, German, Italian, etc.."
          beta={true}
        />

        <DishOption
          name="FreeFlow"
          value={values.FreeFlow}
          handleChange={handleChange}
          isDishePages={isDishePages}
          title="Free Flow"
          placeholder="Cook-E! Please find me something for breakfast that has bacon ..."
        />
      </div>

      <div className="mt-4 md:mt-0">
        {/* Button 1 */}
        <div className="flex flex-col lg:flex-row justify-around w-full gap-4 mt-4">
          <CButton
            label={"Clear"}
            variant={"orange"}
            size={"middle"}
            className={"w-full"}
            // type="reset"
            onClick={() => {
              setValues({
                Culture: "",
                IncludedIngredients: "",
                ExcludedIngredients: "",
                Description: "",
                Occasion: "",
                Language: "",
                FreeFlow: "",
              });
            }}
          />

          <CButton
            variant={"red"}
            size={"middle"}
            className={"w-full"}
            type="submit"
            onClick={onSubmit}
          >
            <IoSearchSharp className="text-xl mr-2 font-bold" />
            {isDishePages ? "Search Dishes" : "Search Recipe"}
          </CButton>
        </div>
      </div>
      {/* </form> */}
    </Layout>
  );
}
